export const getRestStatusCode = (response: { statusCode?: unknown }): number =>
  typeof response.statusCode === 'number' ? response.statusCode : 200;

export const parseRestErrorMessage = (body: string, fallbackMessage: string): string => {
  if (!body) {
    return fallbackMessage;
  }

  try {
    const responseData = JSON.parse(body) as {
      detail?: unknown;
      message?: unknown;
    };

    if (typeof responseData.detail === 'string' && responseData.detail) {
      return responseData.detail;
    }
    if (typeof responseData.message === 'string' && responseData.message) {
      return responseData.message;
    }
  } catch {
    return fallbackMessage;
  }

  return fallbackMessage;
};

const messageFromErrorPayload = (payload: unknown, fallbackMessage: string): string => {
  if (typeof payload === 'string') {
    return parseRestErrorMessage(payload, fallbackMessage);
  }
  if (!payload || typeof payload !== 'object') {
    return fallbackMessage;
  }

  const responseData = payload as {
    detail?: unknown;
    message?: unknown;
  };
  if (typeof responseData.detail === 'string' && responseData.detail) {
    return responseData.detail;
  }
  if (typeof responseData.message === 'string' && responseData.message) {
    return responseData.message;
  }
  return fallbackMessage;
};

export const messageFromAmplifyFailure = (
  response: { body?: unknown; data?: unknown },
  fallbackMessage: string,
): string => {
  if (typeof response.body === 'string' && response.body) {
    return parseRestErrorMessage(response.body, fallbackMessage);
  }
  if (response.data !== undefined) {
    return messageFromErrorPayload(response.data, fallbackMessage);
  }
  return fallbackMessage;
};

export const readOkJson = <T>(
  statusCode: number,
  body: string,
  fallbackMessage: string,
): T => {
  if (statusCode >= 400) {
    throw new Error(parseRestErrorMessage(body, fallbackMessage));
  }
  if (!body) {
    throw new Error(fallbackMessage);
  }
  try {
    return JSON.parse(body) as T;
  } catch {
    throw new Error(fallbackMessage);
  }
};
